import React from 'react';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { IconButton, IconButtonTheme, IconButtonSize, FlyoutDirection } from '@apply/components';
import './../../../scss/controls/_iconflyoutmenubutton.scss';

export const IconFlyoutMenuButton: React.FC<{
    id: string;
    theme: IconButtonTheme;
    size: IconButtonSize;
    disabled?: boolean;
    icon: IconDefinition;
    handleClick?: React.MouseEventHandler;
    hint?: string;
    bubbleNumber?: number;
    children: any;
    direction: FlyoutDirection;
}> = ({ id, theme, handleClick, size, icon, hint, bubbleNumber, disabled, children, direction }) => {
    return (
        <>
            <details className={`iconFlyout ${size}`}>
                <summary role='button'>
                    <IconButton
                        id={id}
                        theme={theme}
                        size={size}
                        disabled={disabled}
                        icon={icon}
                        hint={hint}
                        bubbleNumber={bubbleNumber}
                        handleClick={handleClick}
                    />
                </summary>
                <div className={`iconFlyout container ${size} ${theme} ${direction}`}>{children}</div>
            </details>
        </>
    );
};
